import React from 'react';

import contentPropType from 'bundles/phoenix/models/contentPropType';

// @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
export default React.PropTypes.shape({
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
  typeName: React.PropTypes.oneOf(['yesNo']).isRequired,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
  definition: React.PropTypes.shape({
    prompt: contentPropType.isRequired,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
    points: React.PropTypes.shape({
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
      yes: React.PropTypes.number.isRequired,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
      no: React.PropTypes.number.isRequired,
    }),
  }).isRequired,
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'PropTypes' does not exist on type 'typeo... Remove this comment to see the full error message
  submissionSchemaPartId: React.PropTypes.string,
});
